import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseOptions, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';
import * as ApiConfig from '../core/apiconfig';
import * as Model from './index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';
import * as SharedModel from '../core/index.model';

@Injectable()
export class ProfileService {

    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http) {
        this.apiUrl = ApiConfig.API_URL;
    }

    // Edit Profile
    
    editProfile(citizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_Citizen + "/" + citizenID, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }
    
    // Update Profile

    updateProfile(model: Model.CitizenInfoBase) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + ApiConfig.API_Citizen, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Add Address

    addAddress(model: Model.CitRegAddr) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(this.apiUrl + ApiConfig.API_Citizen + "/" + ApiConfig.API_Address, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Update Address

    updateAddress(model: Model.CitRegAddr) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + ApiConfig.API_Citizen + "/" + ApiConfig.API_Address, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Add Contact

    addContact(model: Model.CitContact) {
        debugger
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(this.apiUrl + ApiConfig.API_Contact, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Update Contact

    updateContact(model: Model.CitContact) {
        debugger
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + ApiConfig.API_Contact, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Delete Contact

    deleteContact(citContactID: string, jurisID: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.delete(this.apiUrl + ApiConfig.API_Contact + "/" + citContactID + "/" + jurisID, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Add Camera

    addCamera(model: Model.CitCamera) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(this.apiUrl + ApiConfig.API_Camera, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Update Camera

    updateCamera(model: Model.CitCamera) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + ApiConfig.API_Camera, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Delete Camera

    deleteCamera(cameraID: string, jurisID: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.delete(this.apiUrl + ApiConfig.API_Camera + "/" + cameraID + "/" + jurisID, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Add Flag

    addFlag(model: Model.CitFlag) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(this.apiUrl + ApiConfig.API_Flag, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Update Flag

    updateFlag(model: Model.CitFlag) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + ApiConfig.API_Flag, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }


    // Delete Flag

    deleteFlag(flagID: string, jurisID: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.delete(this.apiUrl + ApiConfig.API_Flag + "/" + flagID + "/" + jurisID, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Change Password

    changePassword(model: Model.AuthenticationDTO) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + ApiConfig.API_Authentication, model, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }
    //Get GetAddress Details Start
    getAddress(CitizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_Citizen + "/" + ApiConfig.API_GetAddress + "/" + CitizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                if (response.json()[0]) {



                }
                return response.json() as SharedModel.AddressInfo;
            })
            .catch(this.handleError);
    }

    GetCitizenAddressInfo(citizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + ApiConfig.API_Citizen + "/" + citizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json()[0];
            })
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/citizen/profile.service.ts